<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful title="API User Edit :: MeritEHS" />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/admin/api-users`">
                            <i class="fa fa-sitemap"></i> API Users
                        </router-link>
                    </li>
                    <template v-if="UserId">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/admin/api-users/view/${user.UserId}`">
                                {{ user.FirstName }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            Edit
                        </li>
                    </template>
                    <li class="breadcrumb-item active" v-else>
                        New API User
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8">
                    <div class="card">
                        <div class="card-header">Basic Details</div>
                        <div class="card-body">
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.FirstName}">API User Name:</label>
                                <div class="col-sm-8">
                                    <input type="text" v-model="user.FirstName" :class="{'form-control': true, 'is-invalid': errors.FirstName}" placeholder="Enter a Name for this API User (Required)" />
                                    <span v-if="errors.FirstName" class="text-danger">
                                        <span v-for="error in errors.FirstName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.IsActive}">Active:</label>
                                <div class="col-sm-8">
                                    <b-form-radio-group v-model="user.IsActive" class="mt-2">
                                        <b-form-radio value="1">Active</b-form-radio>
                                        <b-form-radio value="0">Inactive</b-form-radio>
                                    </b-form-radio-group>

                                    <span v-if="errors.IsActive" class="text-danger">
                                        <span v-for="error in errors.IsActive">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr/>

                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.regenerate_token}">Re-generate Token:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="regenerate_token" :value="1" :unchecked-value="0" plain class="mt-2"></b-form-checkbox>

                                    <div class="alert alert-warning">NOTE: This will immediately invalidate the existing token and any applications using it will be cut-off from MeritEHS.</div>

                                    <span v-if="errors.regenerate_token" class="text-danger">
                                        <span v-for="error in errors.regenerate_token">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="card mt-3">
                        <div class="card-header"><strong><i class="fa fa-lock"></i> Permissions</strong></div>
                        <div class="card-body">
                            <b-form-checkbox-group v-model="selectedPerms" plain>
                                <div class="row">
                                    <div class="col-lg-6 col-12">
                                        <div v-for="(perm, i) in permsFirstHalf">
                                            <b-form-checkbox :value="perm.id">
                                                {{ perm.name }}
                                            </b-form-checkbox>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-12">
                                        <div v-for="(perm, i) in perms">
                                            <b-form-checkbox :value="perm.id">
                                                {{ perm.name }}
                                            </b-form-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </b-form-checkbox-group>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

            <button type="button" class="btn btn-success" v-on:click="saveUser()" :disabled="saving">
                <template v-if="user.UserId">Update</template>
                <template v-else>Create</template>
                User
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                regenerate_token: 0,
                UserId: this.$route.params.id,
                user: {},
                perms: [],
                selectedPerms: [],
                errors: {},
            }
        },

        computed: {
            isAdmin(){
                return this.$store.state.user.is_admin;
            },

            permsPercol(){
                //Count the Total = 23
                return Math.ceil(this.perms.length / 2);
            },

            permsFirstHalf(){
                //Send it
                return this.perms.splice(0, this.permsPercol);
            },
        },


        methods: {

            restoreUser: function() {
                if (confirm('Are you sure you want to restore this user?'))
                {
                    this.loading = true;

                    this.$http
                        .post(`users/restore/${this.errors.restore_user}`)
                        .then(response => {
                            this.loading = false;
                            this.$router.push('/users/view/' + response.data.UserId);
                        })
                        .catch(response => {

                        });
                }
            },

            reactivateUser: function() {
                this.$router.push(`/users/edit/${this.errors.reactivate_user}`);
            },

            getUser: function() {
                //Get the data
                this.$http
                    .get('admin/api-users/edit' + (this.UserId ? '/' + this.UserId : ''))
                    .then(response => {
                        //Set all the data
                        this.user = response.data.user;
                        this.perms = response.data.perms;
                        this.selectedPerms = response.data.selectedPerms;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveUser: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Set the users perms
                this.user.perms = this.selectedPerms;
                this.user.regenerate_token = this.regenerate_token;

                //Send it
                this.$http
                .post('admin/api-users/edit', this.user)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('API User Saved');

                    //Return to main list?
                    this.$router.push('/admin/api-users/view/' + response.data.UserId);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getUser();
        }
    }
</script>
